import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Top'
import Shampoo from '@/components/Shampoo'
import Concept from '@/components/Concept'
import Voice from '@/components/Voice'
import Menu from '@/components/Menu'
import Access from '@/components/Access'
import Reserve from '@/components/Reserve'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/Shampoo',
      name: 'Shampoo',
      component: Shampoo
    },
    {
      path: '/Concept',
      name: 'Concept',
      component: Concept
    },
    {
      path: '/Voice',
      name: 'Voice',
      component: Voice
    },
    {
      path: '/Menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/Access',
      name: 'Access',
      component: Access
    },
    {
      path: '/Reserve',
      name: 'Reserve',
      component: Reserve
    }
  ]
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     var elem = document.getElementById('ParallaxBase')
  //     if (!elem) {
  //       return 0
  //     }

  //     sessionStorage.setItem('positionY', elem.scrollTop)
  //     return  {
  //       el: '#main',
  //       top: elem.scrollTop,
  //     }
  //   } else {
  //       sessionStorage.setItem('positionY', 0);
  //       return { x: 0, y: 0 }
  //   }
  // }
})

router.afterEach((to, from) => {
  var elem = document.getElementById('ParallaxBase')
  if (elem) {
    setTimeout(() => elem.scrollTop = 0, 1)
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js